import styled, { css } from 'styled-components'

export const DataRow = styled.div(({
  theme: {
    typography, palette,
  },
}) => css`
  font-size: ${typography.tiny.pt_12_medium.fontSize};
  font-weight: ${typography.tiny.pt_12_medium.fontWeight};
  color: ${palette.dark.normal};
  display: flex;
  justify-content: space-between;
`)

export const DataTitle = styled.span(({
  theme: {
    typography, palette,
  },
}) => css`
  font-size: ${typography.main.pt_15_semibold.fontSize};
  font-weight: ${typography.main.pt_15_semibold.fontWeight};
  color: ${palette.black};
`)
